import React from "react";

function EditAnnouncement(){
    return(
        <div className="announcements-button">
            <svg className="icon v1-icon v1-icon-designer--bell announcements-button__icon">
                <use href="#v1-icon-designer--bell" xlinkHref="#v1-icon-designer--bell" />
            </svg>
        </div>
    )
}

export default EditAnnouncement;